// Modify header & footer pdf
import { Card, FooterMenu, HeaderMenu } from "components";
import { LinkAccountContext, LinkAccountProvider } from "pages/Setup/contexts";
import { useContext } from "react";
import { exportPdf } from "utils";
import { PdfLinkAccount } from "../components";
import { TableContent } from "./components";
import { dataAccountLinkInventory, Render, RenderProvider } from "./utils";
import { exportExcel } from "./utils/functions";

export default function LinkAccountInventory() {
  return (
    <RenderProvider>
      <LinkAccountProvider>
        <section className="container pt-5  gap-5 flex flex-col">
          <HeaderMenu title="LINK ACCOUNT INVENTORY" />

          <Card>
            <Card.Body>
              <div className="overflow-x-auto">
                <TableContentSection />
              </div>
            </Card.Body>
          </Card>
          <Footer />
        </section>
      </LinkAccountProvider>
    </RenderProvider>
  )
}

function TableContentSection() {
  const { render } = useContext(Render)

  if (render) {
    return <TableContent />
  } else {
    return <div />
  }
}

function Footer(): JSX.Element {

  const { data } = useContext(LinkAccountContext)

  return (
    <FooterMenu
      export={{
        actiontype: "export",
        onClick: () => exportExcel({
          dataHeader: dataAccountLinkInventory,
          data
        })
      }}
      pdf={{
        actiontype: "pdf",
        onClick: () => {
          exportPdf({
            documentComponent: <PdfLinkAccount
              dataLinkAccount={dataAccountLinkInventory}
              dataList={data}
              title="Link Account Inventory"
            />,
            fileName: "Link Account Inventory"
          })
        }
      }}
    />
  )
}